import { safeDefine } from '@breuni-ui/safe-define';

export default class EntsVideoLayer extends HTMLElement {
  connectedCallback() {
    this.$layer = this.querySelector('#ents-video-modal');
    this.$content = this.$layer.querySelector('.ents-video-layer__container');
    this.isOpen = false;
    this.farbId = null;

    this.videoLayerOpenListener = (e) => {
      const {
        videoUrls,
        poster,
        farbId,
        description
      } = e.detail;
      this.show(videoUrls, poster, farbId, description);
    };

    this.onModalHide = () => {
      if (this.isOpen) {
        this.$content.innerHTML = '';
        this.isOpen = false;
      }
    };

    this.addEventListener('bewe:ents:videoLayerOpen', this.videoLayerOpenListener);
    this.$layer.addEventListener('ents-modal:close', this.onModalHide);
  }

  disconnectedCallback() {
    this.removeEventListener('bewe:ents:videoLayerOpen', this.videoLayerOpenListener);
    this.$layer.removeEventListener('ents-modal:close', this.onModalHide);
  }

  show(videoUrls, poster, farbId, description) {
    this.farbId = farbId;
    const source = v => `<source src="${v.url}" type="${v.type}">`;
    const videoSources = videoUrls
      .map(source)
      .join('');
    this.$content.innerHTML = `<video autoplay playsinline loop muted controls poster="${poster}"
        data-test-ents-video-layer-video aria-label="${description}"
        >${videoSources} </video>`;
    this.isOpen = true;

    this.$layer.classList.remove('hidden');
    this.$layer.show();
  }
}

document.addEventListener('bewe:ents:vue-ready', () => {
  safeDefine('ents-video-layer', EntsVideoLayer);
}, { once: true });
